import styled from "styled-components";

const KidsHeroWrap = styled.div`
  background-color: #f4e1ff;
  padding: 32px 0;
  text-align: center;
  h4 {
    margin-top: -20px;
    font-size: 45px;
    font-weight: 700;
    letter-spacing: 3px;
    text-transform: uppercase;
    margin-bottom: 12px;
  }
`
export default KidsHeroWrap